import {BaseElement} from "../interfaces/BaseElement";
import {isMobile, UIRoot} from "../../settings";
import {logoHandler} from "../menu/menu";
import { Cloudflare } from '../api/Cloudflare';
import { BmbyMode } from '../mode/BmbyMode';

export class ScreenLogo extends BaseElement{
    static #rootElement;

    constructor(logoImageURL) {
        super();
        if (!isMobile) return;

        ScreenLogo.#rootElement = this;
        ScreenLogo.#rootElement
            .addClass('screen-logo')
            .event('click', logoHandler)
            .appendTo(UIRoot);
        new BaseElement('img')
            .addClass('screen-logo__image')
            .appendTo(ScreenLogo.#rootElement.DOMElement)
            .addAttribute('src', Cloudflare.resize(logoImageURL,{height: 50}))
    }

    static show() {
        ScreenLogo.#rootElement?.removeClass('hidden');
    }

    static hide() {
        ScreenLogo.#rootElement?.addClass('hidden');
    }
}
